import React from "react";

import { propTypeChildren } from "@/utils";

import { FormBox, FormFieldBox } from "./style";

function FormWrapper({
  children,
  padding = "40px 56px",
  mobilePadding = "24px",
}) {
  return (
    <FormBox flexDirection={"column"}>
      <FormFieldBox padding={padding} mobilePadding={mobilePadding}>
        {children}
      </FormFieldBox>
    </FormBox>
  );
}

FormWrapper.propTypes = {
  children: propTypeChildren,
};

export default FormWrapper;
